const getGroupActions = settings => {
  const moveToFolderAction = {
    action: (params) => {
      let entries = params.groupData.map(data => data._id);
      // console.log(entries, params.params);
      // uiStateUpdate({data: null},'xpertTriage')
      settings.addPostToQue({
        data: {entries: entries, instance:settings.instance, user: settings.auth.user, value: params.params},
        endPoint: 'saveMultipleEntries',
        update: true,
        cleanup: () => {
          settings.handleDataRefresh('xpertTriage', true, params);
          params.controller.clearGroup();
          params.controller.handlingUpdate = true;
        }
      })
    },
    actionOptions: settings.selectSettings.inboxOptions,
    title: 'Move To Folder',
  }
  const emailBroadcastAction = {
    action: (params) => {
      // console.log(params, 'email boradcast config test.');
      settings.setBroadcasting(params.groupData);
    },
    title: 'Broadcast Email'
  }
  return({
    xpertTriage: {
      triageTraversal: moveToFolderAction,
    },
    searchPatients: {
      emailBroadcast: emailBroadcastAction
    }
  })
}


export default getGroupActions;
